import debugLib from "debug";
const debug = debugLib("prisma:studio-server");

export default debug;
